import { RootStackParamList } from "@/navigation/Root";

export enum SettingsModalTypes {
  TERMS,
}

export type OptionsType = {
  iconName: string;
  title: string;
  stack?: keyof Omit<RootStackParamList, "tabs">;
  route?: string;
  isModal?: boolean;
  modalType?: SettingsModalTypes;
};

export type SessionOptionsType = {
  session: string;
  options: OptionsType[];
};

export const options: SessionOptionsType[] = [
  {
    session: "Minha conta",
    options: [
      {
        iconName: "shopping-cart",
        title: "Meus pedidos",
        stack: "orderStack",
        route: "orderList",
      },
      {
        iconName: "location-pin",
        title: "Endereços de entrega",
        stack: "addressStack",
        route: "addressList",
      },
      {
        iconName: "notifications",
        title: "Notificações",
        stack: "settingsStack",
        route: "notifications",
      },
      {
        iconName: "account-circle",
        title: "Dados pessoais",
        stack: "settingsStack",
        route: "profile",
      },
      {
        iconName: "lock",
        title: "Alterar senha",
        stack: "settingsStack",
        route: "changePassword",
      },
    ],
  },
  {
    session: "Suporte",
    options: [
      {
        iconName: "help",
        title: "Precisa de ajuda?",
        stack: "settingsStack",
        route: "helpCentral",
      },
      {
        iconName: "info",
        title: "Termos e Condições",
        isModal: true,
        modalType: SettingsModalTypes.TERMS,
      },
      {
        iconName: "person-remove",
        title: "Desativar minha conta",
        stack: "settingsStack",
        route: "deactivateAccount",
      },
    ],
  },
];
